export const NEURAL_LANGUAGES = [
  { code: 'all', name: 'All Experts' },
  { code: 'en', name: 'English / Pidgin' },
  { code: 'ach', name: 'Acholi' },
  { code: 'teo', name: 'Ateso' },
  { code: 'fat', name: 'Fante' },
  { code: 'hau', name: 'Hausa' },
  { code: 'ibo', name: 'Igbo' },
  { code: 'kik', name: 'Kikuyu' },
  { code: 'kin', name: 'Kinyarwanda' },
  { code: 'lug', name: 'Luganda' },
  { code: 'lgg', name: 'Lugbara' },
  { code: 'luo', name: 'Luo' },
  { code: 'pcm', name: 'Nigerian Pidgin' },
  { code: 'nyn', name: 'Runyankore' },
  { code: 'swa', name: 'Swahili' },
  { code: 'twi', name: 'Twi' },
  { code: 'wol', name: 'Wolof' },
  { code: 'yor', name: 'Yoruba' },
];

export const NATIVE_NAMES = {
  ach: { male: ['Okwera', 'Otim', 'Opio', 'Obol', 'Ocan', 'Okello', 'Oryem', 'Odong', 'Okot', 'Olara'], female: ['Akello', 'Apiyo', 'Adong', 'Lara', 'Aber', 'Akot', 'Anyango', 'Atim', 'Adengo', 'Amito'] },
  teo: { male: ['Omeda', 'Okurut', 'Odongo', 'Okello', 'Emuria', 'Ilungat', 'Etyang', 'Agaba'], female: ['Akiror', 'Aipo', 'Amuria', 'Teres', 'Asio', 'Apio', 'Akello', 'Aber'] },
  fat: { male: ['Kwame', 'Kofi', 'Kojo', 'Kweku', 'Kobina', 'Kwesi', 'Kwabena'], female: ['Ama', 'Akosua', 'Abena', 'Adjoa', 'Araba', 'Abba', 'Afua'] },
  hau: { male: ['Musa', 'Ibrahim', 'Abubakar', 'Umar', 'Sani', 'Usman', 'Ali', 'Hassan', 'Idris', 'Kabiru'], female: ['Aisha', 'Fatima', 'Amina', 'Zainab', 'Mariam', 'Halima', 'Hadiza', 'Nafisa', 'Rahma', 'Safiya'] },
  ibo: { male: ['Chinedu', 'Emeka', 'Obinna', 'Kelechi', 'Chukwuma', 'Ifeanyi', 'Nonso', 'Tochukwu'], female: ['Nneka', 'Chioma', 'Ifeoma', 'Amaka', 'Ada', 'Ego', 'Oluchi', 'Uzoma'] },
  kik: { male: ['Kamau', 'Maina', 'Mwangi', 'Njoroge', 'Kariuki', 'Kimani', 'Gachanja', 'Macharia'], female: ['Wanjiru', 'Nyambura', 'Muthoni', 'Wangari', 'Njeri', 'Wambui', 'Mumbi', 'Wanjiku'] },
  kin: { male: ['Kagabo', 'Bizimana', 'Uwimana', 'Jean', 'Gakuru', 'Munyaneza'], female: ['Mukamanzi', 'Uwase', 'Mutoni', 'Alice', 'Beata', 'Uwimana', 'Ingabire'] },
  lug: { male: ['Musa', 'Ssemulu', 'Kato', 'Zolo', 'Wasswa', 'Mukasa', 'Kizza', 'Serwadda', 'Musoke', 'Lule'], female: ['Namubiru', 'Nakato', 'Babirye', 'Nantongo', 'Nalumansi', 'Namaganda', 'Nakafeero', 'Namazzi'] },
  lgg: { male: ['Drani', 'Onzima', 'Bello', 'Drileba', 'Anguandia'], female: ['Akello', 'Adokorac', 'Ayikoru', 'Candiru', 'Asio'] },
  luo: { male: ['Otieno', 'Onyango', 'Ochieng', 'Odhiambo', 'Okoth', 'Omondi', 'Owino', 'Odongo'], female: ['Atieno', 'Anyango', 'Adhiambo', 'Achieng', 'Akoth', 'Amondi', 'Awino', 'Adongo'] },
  pcm: { male: ['Chief', 'Bobo', 'Presido', 'Uche', 'Oga', 'Bros', 'Paddy', 'Guy'], female: ['Sisi', 'Queen', 'Faith', 'Blessing', 'Joy', 'Mercy', 'Peace', 'Grace'] },
  nyn: { male: ['Mugisha', 'Tumusiime', 'Karyeiju', 'Niwagaba', 'Bainomugisha', 'Asiimwe'], female: ['Mbabazi', 'Kansime', 'Rose', 'Kyomugisha', 'Atuhaire', 'Amanya', 'Nimusiima'] },
  swa: { male: ['Bakari', 'Juma', 'Hassan', 'Saidi', 'Ali', 'Yusuf', 'Hamisi', 'Ramadhani'], female: ['Fatuma', 'Amina', 'Neema', 'Rehema', 'Zawadi', 'Asha', 'Mariam', 'Halima'] },
  twi: { male: ['Kwesi', 'Yaw', 'Kofi', 'Mensah', 'Boateng', 'Opoku', 'Osei'], female: ['Esi', 'Adwoa', 'Abena', 'Afia', 'Ama', 'Akosua', 'Yaa'] },
  wol: { male: ['Moussa', 'Modou', 'Cheikh', 'Abdou', 'Ousmane', 'Babacar'], female: ['Fatou', 'Mariama', 'Awa', 'Khady', 'Astou', 'Ndeye'] },
  yor: { male: ['Olu', 'Ade', 'Babatunde', 'Segun', 'Femi', 'Kunle', 'Tunde', 'Ayo'], female: ['Bisi', 'Adeoro', 'Funke', 'Yinka', 'Folake', 'Ronke', 'Toyin', 'Nike'] },
};

export const RAW_SPEAKERS = [
  { id: "kin_female_1", lang: "kin", gender: "female" },
  { id: "nyn_female_248", lang: "nyn", gender: "female" },
  { id: "lgg_female_245", lang: "lgg", gender: "female" },
  { id: "teo_female_241", lang: "teo", gender: "female" },
  { id: "ach_female_242", lang: "ach", gender: "female" },
  { id: "swa_male_246", lang: "swa", gender: "male" },
  { id: "swa_female_1", lang: "swa", gender: "female" },
  { id: "swa_male_3", lang: "swa", gender: "male" },
  { id: "fat_male_1", lang: "fat", gender: "male" },
  { id: "fat_female_2", lang: "fat", gender: "female" },
  { id: "fat_male_3", lang: "fat", gender: "male" },
  { id: "fat_female_4", lang: "fat", gender: "female" },
  { id: "hau_male_8", lang: "hau", gender: "male" },
  { id: "hau_male_6", lang: "hau", gender: "male" },
  { id: "hau_female_1", lang: "hau", gender: "female" },
  { id: "hau_female_3", lang: "hau", gender: "female" },
  { id: "hau_male_4", lang: "hau", gender: "male" },
  { id: "hau_male_2", lang: "hau", gender: "male" },
  { id: "hau_female_7", lang: "hau", gender: "female" },
  { id: "hau_female_5", lang: "hau", gender: "female" },
  { id: "ibo_female_1", lang: "ibo", gender: "female" },
  { id: "ibo_female_3", lang: "ibo", gender: "female" },
  { id: "ibo_male_6", lang: "ibo", gender: "male" },
  { id: "ibo_male_4", lang: "ibo", gender: "male" },
  { id: "ibo_male_8", lang: "ibo", gender: "male" },
  { id: "ibo_female_7", lang: "ibo", gender: "female" },
  { id: "ibo_female_5", lang: "ibo", gender: "female" },
  { id: "ibo_male_2", lang: "ibo", gender: "male" },
  { id: "kik_female_2", lang: "kik", gender: "female" },
  { id: "kik_male_4", lang: "kik", gender: "male" },
  { id: "kik_male_1", lang: "kik", gender: "male" },
  { id: "kik_female_3", lang: "kik", gender: "female" },
  { id: "lug_female_4", lang: "lug", gender: "female" },
  { id: "lug_male_3", lang: "lug", gender: "male" },
  { id: "lug_female_5", lang: "lug", gender: "female" },
  { id: "lug_male_2", lang: "lug", gender: "male" },
  { id: "lug_female_8", lang: "lug", gender: "female" },
  { id: "lug_male_1", lang: "lug", gender: "male" },
  { id: "lug_male_6", lang: "lug", gender: "male" },
  { id: "lug_female_7", lang: "lug", gender: "female" },
  { id: "luo_male_3", lang: "luo", gender: "male" },
  { id: "luo_male_4", lang: "luo", gender: "male" },
  { id: "luo_female_3", lang: "luo", gender: "female" },
  { id: "luo_female_4", lang: "luo", gender: "female" },
  { id: "luo_male_1", lang: "luo", gender: "male" },
  { id: "luo_female_1", lang: "luo", gender: "female" },
  { id: "luo_female_2", lang: "luo", gender: "female" },
  { id: "luo_male_2", lang: "luo", gender: "male" },
  { id: "nyn_male_7", lang: "nyn", gender: "male" },
  { id: "nyn_female_5", lang: "nyn", gender: "female" },
  { id: "nyn_male_6", lang: "nyn", gender: "male" },
  { id: "nyn_male_8", lang: "nyn", gender: "male" },
  { id: "nyn_female_4", lang: "nyn", gender: "female" },
  { id: "nyn_female_2", lang: "nyn", gender: "female" },
  { id: "nyn_female_1", lang: "nyn", gender: "female" },
  { id: "nyn_male_3", lang: "nyn", gender: "male" },
  { id: "twi_male_3", lang: "twi", gender: "male" },
  { id: "twi_female_2", lang: "twi", gender: "female" },
  { id: "twi_female_4", lang: "twi", gender: "female" },
  { id: "twi_male_1", lang: "twi", gender: "male" },
  { id: "ach_male_4", lang: "ach", gender: "male" },
  { id: "ach_female_6", lang: "ach", gender: "female" },
  { id: "ach_female_2", lang: "ach", gender: "female" },
  { id: "ach_male_1", lang: "ach", gender: "male" },
  { id: "ach_male_5", lang: "ach", gender: "male" },
  { id: "ach_male_3", lang: "ach", gender: "male" },
  { id: "ach_female_7", lang: "ach", gender: "female" },
  { id: "ach_female_8", lang: "ach", gender: "female" },
  { id: "swa_female_6", lang: "swa", gender: "female" },
  { id: "swa_male_8", lang: "swa", gender: "male" },
  { id: "swa_female_2", lang: "swa", gender: "female" },
  { id: "swa_female_5", lang: "swa", gender: "female" },
  { id: "swa_male_4", lang: "swa", gender: "male" },
  { id: "yor_female_1", lang: "yor", gender: "female" },
  { id: "yor_female_7", lang: "yor", gender: "female" },
  { id: "yor_male_2", lang: "yor", gender: "male" },
  { id: "yor_male_6", lang: "yor", gender: "male" },
  { id: "yor_male_4", lang: "yor", gender: "male" },
  { id: "yor_male_8", lang: "yor", gender: "male" },
  { id: "yor_female_3", lang: "yor", gender: "female" },
  { id: "yor_female_5", lang: "yor", gender: "female" },
  { id: "wol_male_1", lang: "wol", gender: "male" },
  { id: "wol_female_1", lang: "wol", gender: "female" },
  { id: "pcm_male_1", lang: "pcm", gender: "male" },
  { id: "pcm_female_2", lang: "pcm", gender: "female" },
  { id: "pcm_female_4", lang: "pcm", gender: "female" },
  { id: "pcm_female_5", lang: "pcm", gender: "female" },
  { id: "pcm_female_3", lang: "pcm", gender: "female" },
  { id: "pcm_female_1", lang: "pcm", gender: "female" },
  { id: "pcm_male_2", lang: "pcm", gender: "male" },
  { id: "pcm_female_6", lang: "pcm", gender: "female" },
  { id: "pcm_male_3", lang: "pcm", gender: "male" },
  { id: "pcm_male_5", lang: "pcm", gender: "male" }
];

const COLORS = ['#f472b6', '#60a5fa', '#fbbf24', '#34d399', '#F5B844', '#fb7185', '#F5B844', '#fb923c', '#2dd4bf', '#94a3b8', '#facc15'];

const speakerCounters = {};

export const NEURAL_SPEAKERS = RAW_SPEAKERS.map((s, idx) => {
  const key = `${s.lang}_${s.gender}`;
  speakerCounters[key] = (speakerCounters[key] || 0) + 1;
  const currentIdx = speakerCounters[key] - 1;

  const langNames = NATIVE_NAMES[s.lang] || { male: ['Expert'], female: ['Expert'] };
  const nameList = s.gender === 'male' ? langNames.male : langNames.female;
  
  let name = nameList[currentIdx % nameList.length];
  if (currentIdx >= nameList.length) {
    const cycle = Math.floor(currentIdx / nameList.length) + 1;
    name = `${name} ${'I'.repeat(cycle)}`;
  }
  
  const langLabel = NEURAL_LANGUAGES.find(l => l.code === s.lang)?.name || s.lang.toUpperCase();
  
  return {
    ...s,
    name: name,
    persona: `Expert ${langLabel} Voice`,
    color: COLORS[idx % COLORS.length]
  };
}).sort((a, b) => a.name.localeCompare(b.name));

export const NEURAL_LANGUAGE_MAP = {
  'en': ['pcm'], // Map English to Pidgin voices
};
